<template>
    <main-layout>
        <template #header>
            <main-header :title="'시스템 유저' | translate">
            </main-header>
        </template>

        <template #toolbar>
            <main-toolbar>
                <v-spacer></v-spacer>
                <search-bar
                        :placeholder="'검색어를 입력하세요.' | translate"
                        @update:keyword="onFilterChanged"
                        v-model="searchOptions.searchKeyword"
                        style="width: 450px;"
                />
            </main-toolbar>
        </template>

        <template #body>
            <main-body>
                <vue-data-table
                        ref="dataTable"
                        :fetch="fetch"
                        :headers="headers"
                        item-key="raw.noticeId"
                        infinite-pagination
                        :items-per-page="30"
                >
                    <template #item.edit="{ item }">
                        <system-user-edit-form-modal :item="item">
                        </system-user-edit-form-modal>
                    </template>
                    <template #item.permission="{ item }">
                        <v-btn icon @click.stop="onClickPermissionManage(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </vue-data-table>
            </main-body>
        </template>
    </main-layout>
</template>

<script>
    import {PATH} from "@/constants";
    import MainBody from "@/components/common/layout/MainBody";
    import MainToolbar from "@/components/common/layout/MainToolbar";
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import SearchBar from "@/components/input/SearchBar";
    import Notice from "@/model/notice";
    import {dateHelper} from "@/assets/plugins/mps-common/time/date-helper";
    import VueDataTable from "@/assets/plugins/vue-data-table/VueDataTable";
    import SystemUserEditFormModal from "@/components/modal/SystemUserEditFormModal";
    import SystemUser from "@/model/system-user";

    export default {
        name: "SystemUserList",
        components: {
            SystemUserEditFormModal,
            VueDataTable,
            SearchBar,
            MainLayout,
            MainHeader,
            MainToolbar,
            MainBody
        },
        data() {
            return {
                headers: [
                    {
                        text: "아이디",
                        value: "raw.adminUserId",
                        width: 50,
                        sortable: false,
                    },
                    {
                        text: "로그인 아이디",
                        value: "raw.loginId",
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: "Display Name",
                        value: "raw.displayName",
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: "수정",
                        value: "edit",
                        width: 50,
                        sortable: false,
                    },
                    {
                        text: "권한",
                        value: "permission",
                        width: 50,
                        sortable: false,
                    },
                    {
                        text: "국가",
                        value: "raw.countryCode",
                        width: 70,
                        sortable: false,
                    },
                    {
                        text: "언어",
                        value: "raw.languageCode",
                        width: 70,
                        sortable: false,
                    },
                    {
                        text: "그룹 권한",
                        value: "raw.permissionGroupCode",
                        width: 300,
                        sortable: false,
                    },
                    {
                        text: "작성자",
                        value: "raw.register",
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: "수정일시",
                        value: "raw.uptDatetime",
                        read: (v, item) => dateHelper.formatDateTime(v),
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: "등록일자",
                        value: "raw.regDatetime",
                        read: (v, item) => dateHelper.formatDateTime(v),
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: "삭제여부",
                        value: "raw.deleteYn",
                        width: 80,
                        align: 'center',
                        sortable: false,
                    },
                ],
                searchOptions: {
                    searchKeyword: null,
                },
            }
        },
        created() {
        },
        methods: {
            async fetch(pageNumber, pageSize) {
                const res = await this.$request(PATH.ADMIN_USER.LIST)
                    .setObject({
                        ...this.searchOptions,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    })
                    .catch()
                    .enqueue();
                return res.data.map(e => new SystemUser(e))
            },

            /**
             * 필터 조건이 변경되었습니다. 목록을 초기화하고 다시 불러옵니다.
             */
            onFilterChanged() {
                this.$refs.dataTable.clear();
            },

            onClickPermissionManage(item) {
                this.$router.push({name: "managertnbox.sysuser.permission", params: { adminUserId : item.raw.adminUserId }});
            },
        }
    }
</script>

<style scoped>

</style>
